import { FC } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import dayjs from 'dayjs';
import { IMonthlyRateMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: IMonthlyRateMetric | null;
  period?: string;
  height?: number;
}

export const MonthlyRateChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.months || data.months.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <BarChart data={data.months} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="month" tickFormatter={(v) => dayjs(v).format('MMM YY')} tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(_value, _name, props) => {
            const { month, count, rate } = props.payload;
            return [`${count} infortuni · ${rate?.toFixed(2)} per 1000h`, dayjs(month).format('MMMM YYYY')];
          }}
        />
        <Bar dataKey="count" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
